/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */
// 处理TV情况下，安全验证

const getAppVm = () => window.magicApp.$children[0].$children[0];

let toastRewrite = false;

// 重写toast, 针对 " " 不toast
const rewriteToast = () => {
  const oldToast = window.magicApp.__proto__.toast;
  window.magicApp.__proto__.toast = (msg, ms) => {
    if (msg?.trim()) {
      return oldToast(msg, ms);
    }
    console.log('toast nothing');
  };
};

const rewriteResponse = (response) => {
  console.log('rewrite response security');
  // eslint-disable-next-line camelcase
  if (response.frame_resp?.security_verify) {
    response.frame_resp.security_verify.iRet = 0;
  }
  if (response.security_verify) {
    response.security_verify.iRet = 0;
  }
  response.ret = '-1';
  // 加个key, 方便组件内定位问题
  response.__plugin_vip_request = true;
  response.msg = ' ';
  return response;
};

const tvSecurityHandler = (response, request) => {
  // 这些验证码会弹安全组件，TV页面上特殊处理
  const vftValidRet = [102, 103, 104, 105];
  // eslint-disable-next-line camelcase
  const iRet = response?.frame_resp?.security_verify?.iRet || response?.security_verify?.iRet;
  if (vftValidRet.includes(iRet)) {
    // 命中安全策略
    console.log(`命中安全策略: ${JSON.stringify(response)}`);
    // 可以在请求中传入popid或name否则使用默认弹窗
    const pop = request.tvSecurityPop || window.magicTvConfig?.securityPop;
    if (!toastRewrite) {
      rewriteToast();
      toastRewrite = true;
    }
    if (pop && getAppVm()) {
      getAppVm().openPop(pop);
      return rewriteResponse(response);
    }
    const newResponse = rewriteResponse(response);
    newResponse.msg = '该账号暂时无法执行此操作';
    return newResponse;
  }
  return response;
};

export default tvSecurityHandler;
export {
  rewriteToast,
};
